import React from "react";
import Sponsors from "./sponsors";

// Our default page structure as a component to be able to use it from all templates and
// from pages that choose to opt out of complex templates
const PageStructure = ({ children, showSponsors = false }) => (
  <section className="section">
    {showSponsors ? (
      <>
        <Sponsors
          className="is-hidden-touch content"
          style={{ marginTop: "-45px" }}
        />
        <hr className="is-hidden-touch" />
      </>
    ) : (
      false
    )}
    <div className="container">
      <div className="content">{children}</div>
      {showSponsors ? (
        <Sponsors className="is-hidden-desktop content" />
      ) : (
        false
      )}
    </div>
  </section>
);

export { PageStructure };
